import { lazy, Suspense } from 'react';
import { hasRetried } from './_helpers';
import CodeSplitErrorBoundary from './CodeSplitErrorBoundary';
import { PageLoading } from '@/app/ui/page';

const LoadComponentWithRetry = (importFunc, fallback = <PageLoading />) => {
  const Component = lazy(() =>
    importFunc().catch((error) => {
      if (!hasRetried()) {
        // Wait a second and try once more
        return new Promise((resolve) => setTimeout(() => resolve(importFunc()), 1000));
      }
      throw error;
    })
  );

  return (props) => (
    <CodeSplitErrorBoundary>
      <Suspense fallback={fallback}>
        <Component {...props} />
      </Suspense>
    </CodeSplitErrorBoundary>
  );
};

export default LoadComponentWithRetry;
